import React from 'react';
import { getContextConfig } from '../provider';
import { type ConfirmModalProps, createModalElement, SimpleModal } from './createModalElement';

const ConfirmModalBase = SimpleModal as React.ComponentType<ConfirmModalProps>;
export const ConfirmModal = (props: ConfirmModalProps) => <ConfirmModalBase {...props} />;

export const Confirm = (properties: ConfirmModalProps) => {
  const { locale } = getContextConfig();
  const defaultProps: Partial<ConfirmModalProps> = {
    title: locale?.ConfirmModal.title,
    confirmText: locale?.ConfirmModal.confirmText,
    cancelText: locale?.ConfirmModal.cancelText,
  };
  const mergeProps = { ...defaultProps, ...properties };

  return new Promise<boolean>((resolve) => {
    let resolved = false;
    createModalElement<ConfirmModalProps>({
      ...mergeProps,
      onConfirm: () => {
        resolved = true;
        resolve(true);
        mergeProps.onConfirm?.();
      },
      onCancel: () => {
        resolved = true;
        resolve(false);
        mergeProps.onCancel?.();
      },
      onClose: () => {
        // onConfirm/onCancel이 호출된 직후 onClose가 다시 호출되기 때문에 처리 필요
        if (!resolved) {
          resolve(false);
        }
        mergeProps.onClose?.();
      },
    });
  });
};
